import { GET_LEADOM_CONFIG_REQUEST, GET_LEADOM_CONFIG_REQUEST_SUCCESS, GET_LEADOM_CONFIG_REQUEST_FAILURE } from '../constants/leadom_config.constants';

export const getLeadOMConfigRequest = () => ({
    type: GET_LEADOM_CONFIG_REQUEST,
});

export const getLeadOMConfigRequestSuccess = payload => ({
    type: GET_LEADOM_CONFIG_REQUEST_SUCCESS,
    payload,
});

export const getLeadOMConfigRequestFailure = error => ({
    type: GET_LEADOM_CONFIG_REQUEST_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/redux/actions/get_leadomatic_config.actions.js